// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__P58Qs","question":"Question_question__39HYM","description":"Question_description__3e4T-"};